<template>
  <router-view/>
</template>

<script>
import Lockdrop from './components/Lockdrop.vue'

export default {
  name: 'App',
  components: {
    Lockdrop
  }
}
</script>

<style>

@font-face {
    font-family: "SourceCodePro";
    src: local("SourceCodePro"), url(./assets/fonts/SourceCodePro-Regular.ttf) format("truetype");
    font-weight: 400;
    font-style: normal;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #030305;
  color: #ffffffee;
  font-family: VCR;
}

</style>
